// Admin app route table (Phase 5c). /login + /mfa-enroll + /mfa-verify are
// public for unauthenticated/just-authenticated admins; every other route
// is wrapped in RequireAdminAuth which also redirects to /mfa-enroll if
// the admin has not enrolled MFA yet.

import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppShell } from '../components/AppShell';
import { RequireAdminAuth } from '../components/RequireAdminAuth';
import { Login } from '../pages/Login/Login';
import { MfaEnroll } from '../pages/MfaEnroll/MfaEnroll';
import { MfaVerify } from '../pages/MfaVerify/MfaVerify';
import { Home } from '../pages/Home/Home';
import { Tenants } from '../pages/Tenants/Tenants';
import { TenantCreate } from '../pages/TenantCreate/TenantCreate';
import { TenantEdit } from '../pages/TenantEdit/TenantEdit';
import { Migrations } from '../pages/Migrations/Migrations';
import { EmailTemplates } from '../pages/EmailTemplates/EmailTemplates';
import { ModelCatalog } from '../pages/ModelCatalog/ModelCatalog';
import { PlatformAdmins } from '../pages/PlatformAdmins/PlatformAdmins';
import { MiscOps } from '../pages/MiscOps/MiscOps';
import { SystemSettings } from '../pages/SystemSettings/SystemSettings';

export const router = createBrowserRouter([
  { path: '/login', element: <Login /> },
  { path: '/mfa-enroll', element: <MfaEnroll /> },
  { path: '/mfa-verify', element: <MfaVerify /> },
  {
    element: (
      <RequireAdminAuth>
        <AppShell />
      </RequireAdminAuth>
    ),
    children: [
      { index: true, element: <Home /> },
      { path: 'tenants', element: <Tenants /> },
      { path: 'tenants/new', element: <TenantCreate /> },
      { path: 'tenants/:id', element: <TenantEdit /> },
      { path: 'migrations', element: <Migrations /> },
      { path: 'email-templates', element: <EmailTemplates /> },
      { path: 'system-settings', element: <SystemSettings /> },
      { path: 'model-catalog', element: <ModelCatalog /> },
      { path: 'platform-admins', element: <PlatformAdmins /> },
      { path: 'misc-ops', element: <MiscOps /> },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
]);
